import Defaults from '../../constants/defaults';

/**
 * @param {string | number | undefined} value
 * @param {boolean} infinite
 * @returns {number}
 */
const getNumberValue = (value, infinite = false) => {
	const numberValue = typeof value === 'number' ? value : Number.parseInt(value ?? '1', 10);
	return Number.isNaN(numberValue) ? (infinite ? Defaults.KCARDN : 1) : numberValue;
}

export default class Card {
	from = 0;

	to = Defaults.KCARDN;

	/**
	 * @param {string | {from: number, to: number | 'N' } | number} from
	 * @param {number | 'N' | undefined} to
	 */
	constructor(from, to = undefined) {
		if (typeof from === 'string' && to === undefined) {
			const temporaryCard = from.split('-');
			if (temporaryCard.length === 2) {
				this.from = getNumberValue(temporaryCard[0]);
				this.to = getNumberValue(temporaryCard[1], true);
			}
		}
		else if (typeof from === 'object' && 'from' in from && 'to' in from) {
			this.from = getNumberValue(from.from);
			this.to = getNumberValue(from.to, true);
		}
		else {
			this.from = getNumberValue(from);
			this.to = getNumberValue(to, true);
		}
	}

	check() {
		return this.from <= this.to;
	}

	/**
	 * @param {'from' | 'to'} t
	 * @returns {string | undefined}
	 */
	getString(t) {
		if (t === 'from') {
			return `${this.from}`;
		}
		if (t === 'to') {
			return `${this.to === Defaults.KCARDN ? 'N' : this.to}`;
		}
		return undefined;
	}

	isMultiple() {
		return this.to > 1;
	}

	isRequired() {
		return this.from > 0;
	}

	toString() {
		return `${this.getString('from')}-${this.getString('to')}`;
	}
}
